import type { CalendarEvent as CalendarEventType } from '@/lib/utils/calendarUtils';
import { APPOINTMENT_TYPES } from '../../constants/appointmentData';

interface CalendarEventProps {
    event: CalendarEventType;
}

export function CalendarEvent({ event }: CalendarEventProps) {
    const isAppointments = event.resource.type === APPOINTMENT_TYPES.BOOKING;

    const getDotColor = () => {
        if (isAppointments) return 'var(--bg-color-primary-brand-main)';
        return 'var(--color-neutral-main)';
    };

    return (
        <div className='flex items-center'>
            <div className='mr-1 h-2 w-2 flex-shrink-0 rounded-full' style={{ background: getDotColor() }} />
            <span className='overflow-hidden text-xs text-ellipsis whitespace-nowrap'>{event.title}</span>
        </div>
    );
}
